export const steps = [
  { id: 1, label: "User Info" },
  { id: 2, label: "User Preference" },
  { id: 3, label: "Accounting Info" },
];
